export const isSubscriptionActive = (subscriptionStatus) => {
  if (!subscriptionStatus?.is_active) return false;
  if (!subscriptionStatus?.end_date) return true;
  return new Date(subscriptionStatus.end_date).getTime() >= Date.now();
};

export const isRoleFourTrialActive = (createdDate) => {
  if (!createdDate) return false;
  const createdTime = new Date(createdDate).getTime();
  if (Number.isNaN(createdTime)) return false;
  return Date.now() - createdTime <= 3 * 24 * 60 * 60 * 1000;
};

export const storePatientSession = (session) => {
  const user = session?.user;
  if (!session?.token || !user?.id) return false;

  const userRoleId = Number(user.role_id);
  const subscriptionActive = isSubscriptionActive(user.subscription_status);

  localStorage.setItem("token", session.token);
  localStorage.setItem("patientToken", session.token);
  localStorage.setItem("myprega_auth_token", session.token);
  localStorage.setItem("myprega_user", JSON.stringify(user));
  localStorage.setItem("userId", user.id);
  localStorage.setItem("role_id", userRoleId.toString());
  localStorage.setItem("role_name", user.role_name || "");
  localStorage.setItem("user_created_date", user.created_date || "");
  localStorage.setItem(
    "subscription_status",
    JSON.stringify(user.subscription_status || {})
  );
  localStorage.setItem("subscription_end_date", user.subscription_status?.end_date || "");
  localStorage.setItem(
    "isPaidUser",
    userRoleId === 4
      ? subscriptionActive
        ? "true"
        : "false"
      : user?.payment_status === true
        ? "true"
        : "false"
  );
  localStorage.setItem("is_casepaper", user.case_paper_status ?? "");
  return true;
};

export const clearPatientSession = () => {
  [
    "token",
    "patientToken",
    "myprega_auth_token",
    "myprega_user",
    "userId",
    "role_id",
    "role_name",
    "user_created_date",
    "subscription_status",
    "subscription_end_date",
    "isPaidUser",
    "is_casepaper",
  ].forEach((key) => localStorage.removeItem(key));
};

export const getBearerToken = () =>
  localStorage.getItem("patientToken") ||
  localStorage.getItem("myprega_auth_token") ||
  localStorage.getItem("token");
